import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardSkeleton = () => {
  const SkeletonLoader = () => (
    <>
      <Skeleton height={40} width={`90%`} />
      <Skeleton height={20} width={`70%`} style={{ marginTop: "10px" }} />
      <Skeleton height={20} width={`80%`} style={{ marginTop: "10px" }} />
      <Skeleton height={10} width={`70%`} style={{ marginTop: "10px" }} />
    </>
  );
  return (
    <div className="card">
      <div className="card_body">
        <SkeletonLoader />
      </div>
    </div>
  );
};

export default CardSkeleton;
